import express, { Router } from 'express';

import * as projectChargeValidation from '@/modules/projectCharge/projectCharge.validation';
import * as projectChargeController from '@/modules/projectCharge/projectCharge.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECTCHARGE, ACTIONS.READ),
    validateMiddleware(projectChargeValidation.getProjectCharge),
    projectChargeController.getProjectCharges,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECTCHARGE, ACTIONS.CREATE),
    validateMiddleware(projectChargeValidation.createProjectCharge()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    projectChargeController.createProjectCharge,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(
      MODULE_LIST.PROJECTCHARGE,
      ACTIONS.READ,
    ),
    validateMiddleware(projectChargeValidation.getProjectChargeById),
    projectChargeController.getProjectChargeById,
  )
  .patch(
    userAuthAndCheckPermissions(
      MODULE_LIST.PROJECTCHARGE,
      ACTIONS.UPDATE,
    ),
    validateMiddleware(projectChargeValidation.updateProjectCharge()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    projectChargeController.updateProjectCharge,
  )
  .delete(
    userAuthAndCheckPermissions(
      MODULE_LIST.PROJECTCHARGE,
      ACTIONS.DELETE,
    ),
    validateMiddleware(projectChargeValidation.deleteProjectChargeById),
    projectChargeController.deleteProjectChargeById,
  );

export default router;
